export default __webpack_public_path__ + "static/media/GGL.6fb2215a.png";